import { EditorConfig, LexicalEditor, LexicalNode } from "lexical";
import { Decorable, GConstructor } from "./general";

type InlineCtor = GConstructor<Decorable>;

export function InlineMixin<TBase extends InlineCtor>(Base: TBase) {
  return class Inline extends Base {
    createDOM(config: EditorConfig, editor: LexicalEditor) {
      const dom = super.createDOM(config, editor);
      dom.style.display = 'inline-block';
      dom.style.position = 'relative';
      dom.style.textIndent = 'initial';  // so it would not inherit from parent
      dom.style.maxWidth = '100%';
      return dom;
    }

    updateDOM(_prevNode: unknown, _dom: HTMLElement, _config: EditorConfig): boolean {
      super.updateDOM(_prevNode, _dom, _config);
      return false
    }

    isInline() {
      return true;
    }
  };
}

type Inline = InstanceType<ReturnType<typeof InlineMixin<InlineCtor>>>;

export const $isInlineNode = (node: LexicalNode): node is Inline => {
  return Boolean(node && node.isInline());
}